import { createFileRoute, redirect } from "@tanstack/react-router"

/**
 * The microsite has no contact form of its own.
 *
 * PLAYBRAIN's contact page already handles enquiries, is wired to the mailer
 * that is actually monitored, and carries the enquiry-type routing the team
 * relies on. A second form would be a second inbox to watch and a second thing
 * to keep working, for the same question.
 */
export const Route = createFileRoute("/$locale/playdata/contact")({
  beforeLoad: ({ params }) => {
    throw redirect({ params: { locale: params.locale }, to: "/$locale/contact" })
  },
})
